// extracted by mini-css-extract-plugin
export default {"titlesContainer":"AboutMe_titlesContainer__RlcjI"};